class CartDrawer {
    constructor() {
        this.drawer = document.getElementById('CartDrawer');
        if (!this.drawer) return;

        this.content = this.drawer.querySelector('.cart-drawer__content');
        this.closeButtons = this.drawer.querySelectorAll('.js-cart-drawer-close');
        this.init();
    }

    init() {
        // Close events
        this.closeButtons.forEach(btn => {
            btn.addEventListener('click', () => this.close());
        });

        // Close on Escape
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isOpen()) this.close();
        });

        // Event delegation for actions inside the drawer
        this.drawer.addEventListener('click', (e) => {
            const target = e.target.closest('[data-action]');
            if (!target) return;

            const action = target.dataset.action;
            const key = target.closest('[data-key]')?.dataset.key;
            if (!key) return;

            const input = target.closest('[data-key]').querySelector('.drawer-qty-input');
            let quantity = parseInt(input.value);

            if (action === 'increase') quantity++;
            else if (action === 'decrease') quantity--;
            else if (action === 'remove') quantity = 0;

            if (quantity >= 0) this.updateItem(key, quantity);
        });

        // Manual input change
        this.drawer.addEventListener('change', (e) => {
            if (e.target.classList.contains('drawer-qty-input')) {
                const key = e.target.dataset.key;
                const quantity = parseInt(e.target.value);
                if (quantity >= 0) this.updateItem(key, quantity);
            }
        });
    }

    open() {
        this.drawer.querySelector('.cart-drawer').classList.add('is-open');
        document.body.classList.add('overflow-hidden');
    }

    close() {
        this.drawer.querySelector('.cart-drawer').classList.remove('is-open');
        document.body.classList.remove('overflow-hidden');
    }

    isOpen() {
        return this.drawer.querySelector('.cart-drawer').classList.contains('is-open');
    }

    async updateItem(key, quantity) {
        this.drawer.querySelector('.cart-drawer').classList.add('is-loading');

        try {
            const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({ id: key, quantity })
            });

            if (!response.ok) throw new Error('Network response was not ok');

            const cart = await response.json();
            await this.refresh();

            // Update header bubbles if they exist
            this.updateHeaderBubbles(cart.item_count);

        } catch (error) {
            console.error('Error updating cart:', error);
        } finally {
            this.drawer.querySelector('.cart-drawer').classList.remove('is-loading');
        }
    }

    async refresh() {
        // Fetch the cart drawer section specifically
        const response = await fetch(`${window.location.pathname}?section_id=cart-drawer`);
        const htmlText = await response.text();

        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlText, 'text/html');
        const newContent = doc.querySelector('.cart-drawer').innerHTML;

        if (newContent) {
            this.drawer.querySelector('.cart-drawer').innerHTML = newContent;
            // Re-bind close events if they were inside the replaced HTML (header is usually replaced)
            this.initCloseButtons();
        }
    }

    initCloseButtons() {
        this.drawer.querySelectorAll('.js-cart-drawer-close').forEach(btn => {
            btn.onclick = () => this.close();
        });
    }

    updateHeaderBubbles(count) {
        const bubbles = document.querySelectorAll('.cart-count-bubble');
        bubbles.forEach(bubble => {
            bubble.textContent = count;
            if (count > 0) bubble.classList.remove('hidden');
            else bubble.classList.add('hidden');
        });
    }
}

// Initialize and expose globally for other scripts to use
window.cartDrawer = new CartDrawer();

// Event listener for custom cart:open event if needed
document.addEventListener('cart:open', () => {
    if (window.cartDrawer) window.cartDrawer.open();
});

// Event listener for cart updates from other scripts
document.addEventListener('cart:updated', async (event) => {
    if (window.cartDrawer) {
        await window.cartDrawer.refresh();
        if (event.detail?.open) window.cartDrawer.open();
    }
});
